

























import Vue from "vue";
import Component from "vue-class-component";
import { Model, Prop } from "vue-property-decorator";
import { getElement } from "@/lib/elementHelpers";

@Component({ name: "BaseCheckbox" })
export default class BaseCheckbox extends Vue {
  @Model("input", { type: Boolean, required: true })
  public readonly checked!: boolean;

  @Prop({ type: Boolean, default: false })
  public readonly disabled!: boolean;

  public click() {
    (getElement(this.$refs.checkbox) as HTMLInputElement).click();
  }
}
